export const KLIPS_CTA = {
  title: "Level up your decision making",
  description: "Create custom dashboards for you and your team.",
}

export const POWERMETRICS_CTA = {
  title: "Level up data-driven decision making",
  description: "Make metric analysis easy for everyone.",
}

export const AGNOSTIC_CTA = {
  title: "Supercharge your analytics",
  description: "Harness the power of data-driven decision making.",
}
